import React, { useState } from "react";
import hide from "../../images/hide.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import { useMutation } from "@apollo/react-hooks";
import { FORGOT_PASSWORD } from "../../mutation/ForgotPassword";
import FullWidthLayout from "../Common/FullwidthLayout";

const ForgotPassword = (props) => {
  const history = useHistory();
  const { id } = props.match.params;
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [visiblePassword2, setVisiblePassword2] = useState(false);
  const [correctpassworderror, setCorrectPasswordError] = useState(false);
  const [ForgotPasswordMutation] = useMutation(FORGOT_PASSWORD);
  const token = id;

  return (
    <FullWidthLayout>
      <div className="login-cover">
        <div className="login-box change-password">
          <h2>Choose a new password</h2>
          <p>Please choose a new password</p>
          {/* <div className="left-arrow">
                    <img src={arrow} alt="arrow" />
                </div> */}

          <Formik
            initialValues={{ password: "", confirmpassword: "" }}
            validateOnChange={false}
            validateOnBlur={true}
            validationSchema={Yup.object({
              password: Yup.string()
                .required("Please enter your password")
                .min(
                  8,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[a-z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[A-Z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /.*[0-9].*/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /(?=.*[!@#$%^&*])/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                ),
              confirmpassword: Yup.string()
                .required("Please enter your password")
                .min(
                  8,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[a-z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[A-Z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /.*[0-9].*/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /(?=.*[!@#$%^&*])/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                ),
            })}
            validate={(values) => {
              const passWordError = {};
              if (values.password !== values.confirmpassword) {
                setCorrectPasswordError(true);
                passWordError.confirmpassword = "";
              }
              if (values.confirmpassword === "") {
                setCorrectPasswordError(false);
                passWordError.confirmpassword =
                  "Please enter your confirm password";
              }

              return passWordError;
            }}
            onSubmit={(values, { setFieldError, setSubmitting }) => {
              ForgotPasswordMutation({
                variables: {
                  resetPasswordToken: token,
                  newPassword: values.password,
                },
              })
                .then(() => {
                  setSubmitting(false);
                  history.push("/login");
                  localStorage.setItem("reset_password_successful", true);
                })
                .catch((e) => {
                  const errors = e.graphQLErrors;
                  if (
                    errors[0] &&
                    errors[0].message &&
                    errors[0].message === "Reset Password token is Expired"
                  ) {
                    setFieldError(
                      "password",
                      "Reset Password token is Expired"
                    );
                  } else if (
                    (errors[0] && errors[0].message) ||
                    "password must contain one uppercase, lowercase, number and symbol"
                  ) {
                    setFieldError("password", errors[0].message);
                  }
                  setSubmitting(false);
                });
            }}
          >
            {({ isSubmitting }) => (
              <Form className="login-form">
                <div className="form-group">
                  <label>Password</label>
                  <div className="hide-icon">
                    <Field
                      type={visiblePassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                    />
                    <img
                      onClick={() => setVisiblePassword(!visiblePassword)}
                      src={hide}
                      alt="password hide"
                    />
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label>Confirm Password</label>
                  <div className="hide-icon">
                    <Field
                      type={visiblePassword2 ? "text" : "password"}
                      name="confirmpassword"
                      className="form-control"
                    />
                    <img
                      onClick={() => setVisiblePassword2(!visiblePassword2)}
                      src={hide}
                      alt="password hide"
                    />
                  </div>
                  {correctpassworderror ? (
                    <div className="error-message">
                      {" "}
                      Passwords Does Not Match{" "}
                    </div>
                  ) : null}
                  <ErrorMessage
                    name="confirmpassword"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-submit">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isSubmitting}
                  >
                    Reset Password
                  </button>
                </div>
              </Form>
            )}
          </Formik>

          {/* <form className="login-form">                                       
                    <div className="form-group">
                        <label>Password</label>  
                        <div className="hide-icon">                  
                            <input type="Password" className="form-control" />                        
                            <img src={hide} alt="password hide"/>
                        </div>                        
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>  
                        <div className="hide-icon">                  
                            <input type="Password" className="form-control" />                        
                            <img src={hide} alt="password hide"/>
                        </div>                        
                    </div>
                    <div className="form-submit">
                        <input type="submit" className="submit-btn" value="Login" />
                    </div>
                </form> */}
        </div>
      </div>
    </FullWidthLayout>
  );
};

export default ForgotPassword;
